<template>
  <div class="edit">
    <h2 class="tab-title">
      {{ $t("Fill the document") + (userEmail ? "" : " [" + refEmail + "]") }}
    </h2>
    <md-progress-spinner
      v-if="loading"
      :md-diameter="100"
      :md-stroke="5"
      md-mode="indeterminate"
      style="
        position: absolute;
        z-index: 5;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    ></md-progress-spinner>
    <button
      class="send-email-btn"
      @click="submitSign()"
      style="right: 140px"
      :disabled="disableSubmit"
    >
      <md-icon style="color: white">save</md-icon> <span>Submit</span>
    </button>
    <md-dialog :md-active.sync="showPwdForm">
            <md-dialog-title>Password required</md-dialog-title>
            <div style="padding: 15px">
              <form action="" autocomplete="off">
                <md-field>
                  <label>Password</label>
                  <md-input
                    v-model="pw"
                    type="password"
                    autocomplete="off"
                  ></md-input>
                </md-field>
          
              </form>
              <div style="color:red; font-size: 12px;" v-if="wrong_pw">Wrong password</div>
            </div>
            <md-dialog-actions>
        
              <md-button
                class="md-primary"
                :disabled="!pw"
                @click="
                  validatePwd()
                "
                >Submit</md-button
              >
             
            </md-dialog-actions>
          </md-dialog>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Field properties</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <md-select
            v-model="recipient"
            name="email"
            id="email"
            placeholder="Recipient who fill"
          >
            <md-option
              v-for="email in emails"
              :value="JSON.stringify(email)"
              v-bind:key="email.email"
              :style="{
                'border-left': '6px solid',
                'border-color': email.color,
              }"
              >{{ email.email }}</md-option
            >
          </md-select>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="showDialog = false">Cancel</md-button>
        <md-button class="md-primary" @click="doAddField(newFieldType)"
          >Save</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <div class="pdf-pagination" style="height: 45px">
      <div
        row
        wrap
        style="
          display: flex;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
        "
      >
        <md-button
          class="md-icon-button md-raised"
          :disabled="noPrevPage"
          @click="prevPage"
        >
          <md-icon>navigate_before</md-icon>
        </md-button>

        <!-- <md-button class="md-raised">First</md-button> -->

        <div xs8 style="margin-top: 10px">
          {{ currentPage }} / {{ pageCount }}
        </div>

        <!-- <md-button class="md-raised">Last</md-button> -->
        <md-button
          class="md-icon-button md-raised"
          :disabled="noNextPage"
          @click="nextPage"
        >
          <md-icon>navigate_next</md-icon>
        </md-button>
        <div style="transform: translate(20px, -6px)">
          <md-button
            class="md-fab md-mini md-primary"
            style="box-shadow: none"
            @click="()=>{
let step = pageZoom%0.25 ==0?0.25:(pageZoom%0.25).toFixed(2);
 return pageZoom-step<0.25?pageZoom=0.25: pageZoom-= step;
            }"
            :disabled="pageZoom<=0.5"
          >
            <md-icon>zoom_out</md-icon>
          </md-button>
          <md-input type="number" step="25" min="50" max="200" style="width: 50px;
    text-align: right;
    margin-top: 17px;
    border: 1px solid #cec3c3;
    border-radius: 3px;" v-model="pageZoomAux" @blur.native="pageZoomValidate"  @input.native="pageZoomInput" @keyup.enter="pageZoomValidate"></md-input>
         
          <md-button
            class="md-fab md-mini md-primary"
            style="box-shadow: none"
            :disabled="pageZoom>=2"
            @click="()=>{
let step = 0.25 - (pageZoom%0.25).toFixed(2);
 return pageZoom+step>2?pageZoom=2: pageZoom+= step;
 
            }"
          >
            <md-icon>zoom_in</md-icon>
          </md-button>
        </div>
      </div>
    </div>
    <div class="pdf-image-flieds-container" :style="'zoom:' + pageZoom">
      <div style="position: relative">
        <div>
          <img
            id="pdf-image"
            :src="pages[currentPage - 1]"
            alt=""
            :onload="onLoadImg()"
            style="
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            "
          />
        </div>
      </div>
      <div style="position: relative; width: 100%">
        <div style="position: absolute; left: 50%; transform: translateX(-50%)">
          <div id="fields-cont" style="position: relative">
            <component
              v-for="field in fields"
              :style="
                shownFields.indexOf(field) == -1
                  ? 'display:none!important;'
                  : ''
              "
              :is="field"
              :key="field.tmpId"
              :ref="field.tmpId"
            ></component>
          </div>
        </div>
      </div>
    </div>

    <md-speed-dial
      class="md-bottom-right email-legend"
      md-event="click"
      style="align-items: flex-end; position: fixed; z-index: 2"
    >
      <md-speed-dial-target>
        <md-icon>email</md-icon>
      </md-speed-dial-target>

      <md-speed-dial-content style="align-items: flex-end">
        <md-button
          v-for="(color, email) in recipientColors"
          :key="email"
          disabled
          style="background: none !important"
        >
          <div style="display: flex">
            <div
              :style="{
                'text-transform': 'none',
                color: 'rgba(0,0,0,.7)',
                'margin-right': '5px',
                background: 'white',
                padding: '5px 10px',
                'border-radius': '5px',
                'box-shadow': 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
              }"
            >
              {{
                findRecipientName(email)
                  ? findRecipientName(email) + " (" + email + ")"
                  : email
              }}
            </div>
            <div
              :style="{
                background: color,
                'border-radius': '50%',
                display: 'inline-block',
                height: '20px',
                width: '20px',
                'margin-right': '10px',
                'margin-top': '5px',
              }"
            ></div>
          </div>
        </md-button>
      </md-speed-dial-content>
    </md-speed-dial>

    <md-snackbar
      md-position="center"
      :md-duration="5000"
      :md-active.sync="showSnackbar"
      md-persistent
      style="bottom: 45px"
    >
      <span>{{ snackbarMsg }}</span>
    </md-snackbar>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import pdf from "vue-pdf";
import VueDragResize from "vue-drag-resize";
import DragResizeField from "@/components/DragResizeField.vue";
import SignField from "@/components/SignField.vue";
import DynamicField from "@/components/DynamicField.vue";
// var initDocHeight;
export default {
  name: "Fill",
  components: {
    pdf,
    VueDragResize,
    DragResizeField,
    SignField,
    DynamicField,
  },
  mounted() {
    Vue.prototype.$signPadData = [];
    var vm = this;
    vm.loading = true;
    setInterval(() => {
      let bool=true;
      if(this.transactionData.fields){
  bool=   this.transactionData.fields.filter(
        (field) =>{
          
          return field.owner == this.userEmail && field.required && !field.image;
        }
      ).length > 0;
      }
     
      this.disableSubmit=bool;

    }, 500);
    axios({
      method: "get",
      url: "/sign/transaction",
      baseURL: process.env.VUE_APP_BASE_API,
      headers: {
        ref: vm.$route.query.ref,
        Authorization: "Bearer " + Vue.prototype.$userData.tokens.access.token,
      },
      params: {
        transactionId: vm.$route.query.transactionId,
      },
    })
      .then((response) => {
        console.log("SUCCESS trn!!");
        console.log(response);
        vm.transactionData = response.data;
        vm.sign_document = response.data.sign_document;
if(!vm.transactionData.doc_password){
  vm.getDocument();
}else{
  vm.showPwdForm=true;
}

        if (!vm.$route.query.transactionId) {
          vm.$route.query.transactionId = vm.transactionData.id;
        }
        vm.refEmail = vm.transactionData.refEmail;
        if (!Vue.prototype.$userData.user.email) {
          Vue.prototype.$userData.user.email = vm.refEmail;
        }

        if (vm.transactionData.signStatus >= 5) {
          vm.showSnackbar = true;
          vm.loading = false;
          return;
        } else if (
          !vm.transactionData.processed.recipients.some(function (ele) {
            return (ele.mail?.toLowerCase() === vm.refEmail?.toLowerCase()) && !ele.finished;
          })
        ) {
          vm.snackbarMsg = "You already signed this document!";
          vm.showSnackbar = true;
          vm.loading = false;
          return;
        }

    

        for (let i = 0; i < vm.transactionData.recipients.length; i++) {
          vm.recipientColors[vm.transactionData.recipients[i]] =
            vm.colors.shift();
        }

        setTimeout(function () {
          document.querySelector(".email-legend .md-speed-dial-target").click();
        }, 0);
        if (vm.transactionData.fields) {
          for (
            let index = 0;
            index < vm.transactionData.fields.length;
            index++
          ) {
            const field = vm.transactionData.fields[index];

            vm.doAddField(field);
          }
        }


      })
      .catch(function () {
        console.log("FAILURE!!");
        vm.loading = false;
        vm.showSnackbar = true;
      });

    this.emails = JSON.parse(localStorage.getItem("recipients"));
    console.log(this.emails);

    window.initDocHeight = document.querySelector("#pdf-image").offsetHeight;
    window.initDocWidth = document.querySelector("#pdf-image").offsetWidth;

    function reportWindowSize() {
      var imgPdf = document.getElementById("pdf-image");
      var fieldsCont = document.getElementById("fields-cont");
      fieldsCont.style.height = imgPdf.offsetHeight + "px";
      fieldsCont.style.width = imgPdf.width + "px";

      var newDocHeight = document.querySelector("#pdf-image").offsetHeight;
      var newDocWidth = document.querySelector("#pdf-image").offsetWidth;
      var zoom;

      if (window.initDocWidth < newDocWidth) {
        zoom = newDocHeight / window.initDocHeight;

        if (zoom * window.initDocWidth > newDocWidth) {
          zoom = newDocWidth / window.initDocWidth;
        }
      } else {
        zoom = newDocWidth / window.initDocWidth;

        if (zoom * window.initDocHeight > newDocHeight) {
          zoom = newDocHeight / window.initDocHeight;
        }
      }

      // var scale= newDocHeight / window.initDocHeight;
      document.getElementById("fields-cont").style.zoom = zoom * 0.95;
      console.log(newDocHeight);
      // window.initDocHeigh=newDocHeight;
    }

    window.onresize = reportWindowSize;
  },
  data() {
    return this.initialData();
  },
  computed: {
    userEmail: {
      cache: false,
      get() {
        return Vue.prototype.$userData.user.email || this.$route.query.email;
      },
    },
    noPrevPage() {
      return this.currentPage <= 1;
    },
    noNextPage() {
      return this.currentPage === this.pageCount;
    },
  },

  watch: {
    pageZoom: function (newVal) {
      this.pageZoomAux=Math.round(newVal*100);

     
    },
  },

  methods: {
    pageZoomInput(event){
            if (!event.inputType||event.inputType === "increment" || event.inputType === "decrement") {
  this.pageZoomValidate();
}
    },
    pageZoomValidate() {
      const vm =this;
let validZoom= false;
const newVal=vm.pageZoomAux/100;
if(newVal>2){
      vm.pageZoom=2;
     }else  if(newVal<0.25){
      vm.pageZoom=0.25;
     }else{
      validZoom= true;
      vm.pageZoom=Number(newVal);
     }

     if(!validZoom){
      Vue.$toast.open({
              message: "The zoom value must be between 25% and 200%",
              position: "bottom",
              type: "default",
            });
     }
     
    },
    validatePwd(){
      const vm=this;
if(vm.pw == vm.transactionData.doc_password){
  vm.getDocument();
vm.showPwdForm=false
vm.wrong_pw=false;
}else{
  vm.wrong_pw=true;
  vm.pw='';

}
    },
    getDocument(){
const vm=this;
      axios({
          method: "post",
          url: "/sign/getDocument",
          baseURL: process.env.VUE_APP_BASE_API,
          headers: {
            ref: vm.$route.query.ref,
            Authorization:
              "Bearer " + Vue.prototype.$userData.tokens.access.token,
          },
          data: {
            docId: vm.sign_document,
          },
        })
          .then((response) => {
            console.log(" docSUCCESS!!");
            console.log(response);
            vm.currentPageImg = response.data.pages[0];
            vm.pages = response.data.pages;
            vm.pageCount = vm.pages.length;
            vm.loading = false;
          })
          .catch(function (error) {
            console.log(error, " doc FAILURE!!");
            vm.loading = false;
          });



    },
    initialData() {
      return {
        pageZoomAux:100,
        showPwdForm: false,
        wrong_pw: false,
        disableSubmit: true,
        refEmail: "",
        pw: "",
        showSnackbar: false,
        snackbarMsg: "You do not have permissions to access this document.",
        pageZoom: 1,
        pages: [],
        loading: false,
        currentPageImg: null,
        transactionData: {},
        sign_document: "",
        currentPage: 1,
        pageCount: 0,
        src: null,
        zoom: 100,
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        fields: [],
        shownFields: [],
        emails: [],
        showDialog: false,
        newFieldType: "",
        recipient: "",
        colors: [
          "#7CB9E8",
          "#9966CC",
          "#E52B50",
          "#F19CBB",
          "#3B7A57",
          "#FFBF00",
          "#FF7E00",
          "#841B2D",
          "#008000",
          "#007FFF",
          "#87421F",
        ],
        recipientColors: {},
      };
    },

    download() {
      const vm = this;
      vm.loading = true;
      axios({
        method: "post",
        url: "/sign/download",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          ref: vm.$route.query.ref,
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: {
          docId: vm.sign_document,
        },
      })
        .then((response) => {
          console.log(" downSUCCESS!!");
          console.log(response);
          vm.loading = false;
        })
        .catch(function () {
          console.log(" down FAILURE!!");
          vm.loading = false;
        });
    },
    submitSign() {
      var vm = this;
      vm.loading = true;
      delete vm.transactionData.id;

      for (let index = 0; index < vm.transactionData.names.length; index++) {
        delete vm.transactionData.names[index].color;
        delete vm.transactionData.names[index]._id;
      }

      axios({
        method: "put",
        url: "/sign/transaction",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          ref: vm.$route.query.ref,
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        params: {
          transactionId: vm.$route.query.transactionId,
        },
        data: vm.transactionData,
      })
        .then(() => {
          console.log("SUCCESS!!");

          axios({
            method: "post",
            url: "/sign/sign",
            baseURL: process.env.VUE_APP_BASE_API,
            headers: {
              ref: vm.$route.query.ref,
              Authorization:
                "Bearer " + Vue.prototype.$userData.tokens.access.token,
            },
            data: {
              transactionId: vm.$route.query.transactionId,
            },
          })
            .then(() => {
              console.log("SUCCESS!!");
              vm.$router.push({
                path: "trail",
                query: {
                  transactionId: vm.$route.query.transactionId,
                  ref: vm.$route.query.ref,
                },
              });
              vm.loading = false;
            })
            .catch(function () {
              console.log("FAILURE!!");
              vm.showSnackbar=true;
              vm.snackbarMsg='Server error trying to Sign the document';
              vm.loading = false;
            });
        })
        .catch(function () {
          console.log("FAILURE!!");
          vm.loading = false;
        });
    },

    onLoadImg() {
      setTimeout(function () {
        var imgPdf = document.getElementById("pdf-image");
        var fieldsCont = document.getElementById("fields-cont");
        fieldsCont.style.height = imgPdf.offsetHeight + "px";
        fieldsCont.style.width = imgPdf.width + "px";
      }, 0);
    },

    prevPage() {
      this.currentPage--;
      this.updateFields();
    },
    nextPage() {
      this.currentPage++;
      this.updateFields();
    },
    resize(newRect) {
      this.width = newRect.width;
      this.height = newRect.height;
      this.top = newRect.top;
      this.left = newRect.left;
    },
    pageLoaded(event) {
      this.currentPage = event;
      window.initDocHeight = document.querySelector("#pdf-viewer").offsetHeight;
      console.log("pageloaded");
      console.log(window.initDocHeight);
    },
    addField(type) {
      this.showDialog = true;
      this.newFieldType = type;
    },
    doAddField(field) {
      var vm = this;
      var fields = vm.fields;
      // vm.showDialog=false;
      delete field._id;

      let disableField =
        (Vue.prototype.$userData.user.email ||
          vm.$route.query.email ||
          vm.refEmail)?.toLowerCase() != field.owner?.toLowerCase();
const index =fields.length - 1;
      fields.push({
        render(h) {
          return h(DynamicField, {
            class: ["foo"],
            template: "<span>holi</span>",
            on: {
              fieldProps: function (val) {
                field.fieldProps = val;
              },
              rawValue: function (val) {
                field.rawValue = val;
              },
              change: function (val) {
                field.image = val;
                // if (val) {
                //   var img = new Image();
                //   img.onload = function () {
                //     var canvas = document.createElement("canvas"),
                //       ctx = canvas.getContext("2d");

                //     var MAX_WIDTH = field.width;
                //     var MAX_HEIGHT = field.height;
                //     var width = img.width;
                //     var height = img.height;

                //     if (height > MAX_HEIGHT) {
                //       width *= MAX_HEIGHT / height;
                //       height = MAX_HEIGHT;

                //       if (width > MAX_WIDTH) {
                //         height *= MAX_WIDTH / width;
                //         width = MAX_WIDTH;
                //       }
                //     }

                //     canvas.width = width;
                //     canvas.height = height;
                //     ctx.drawImage(img, 0, 0, width, height);

                //     field.image = canvas.toDataURL();
                //   };
                //   img.src = val;
                // } else {
                //   field.image = undefined;
                // }
              },
            },
            props: {
              value: field.image || null,
              top: field.top,
              left: field.left,
              width: field.width,
              height: field.height,
              owner: field.owner,
              required: field.required,
              signMethods: field.signMethods,
              color: vm.recipientColors[field.owner],
              name: vm.findRecipientName(field.owner),
              disabled: disableField,
              type: disableField && field.image ? "sign" : field.type || "date",
              index: index,
            },
          });
        },
      });
      fields[fields.length - 1].page = field.page;

      this.updateFields();
    },
    findRecipientName(email) {
      var data = this.transactionData.names.find((el) => {
        return el.email == email;
      });
      if (data) {
        return data.name;
      } else {
        return false;
      }
    },
    updateFields() {
      var vm = this;

      this.shownFields = this.fields.filter(function (el) {
        return el.page == vm.currentPage;
      });
    },
  },
  beforeDestroy() {
    Object.assign(this.$data, this.initialData());
  },
};
</script>

<style >
.md-datepicker-body-content {
    min-height: 264px;
}
.tab-title {
  color: #a5a5a5;
  margin-bottom: 30px;
}
.edit {
  margin: 10px;
}

.send-email-btn:disabled {
  background: #dddddd;
  box-shadow: none;
  cursor: default;
}

.send-email-btn {
  margin: 0;
  padding: 0;
  display: inline-block;
  position: relative;
  overflow: hidden;
  outline: none;
  background: transparent;
  border: 0;
  border-radius: 0;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
  line-height: normal;
  text-decoration: none;
  vertical-align: top;
  white-space: nowrap;
  min-width: 88px;
  height: 36px;
  margin: 6px 8px;
  -webkit-user-select: none;
  user-select: none;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  top: 45px;
  right: 30px;
  cursor: pointer;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  color: #fff;
  color: var(--md-theme-default-text-primary-on-primary, #fff);
  background-color: #e94e1b;
  /* background-color: var(--md-theme-default-primary, #e94e1b); */
  position: absolute;
}
.send-email-btn a {
  color: white !important;
  font-weight: bold !important;
}

.md-button-content .md-checkbox {
  width: 150px;
}

.md-button-content input {
  width: 130px;
}

label,
.md-checkbox-label {
  text-transform: none !important;
}
.send-email-btn {
  margin: 0;
  padding: 0;
  display: inline-block;
  position: relative;
  overflow: hidden;
  outline: none;
  background: transparent;
  border: 0;
  border-radius: 0;
  transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  font-family: inherit;
  line-height: normal;
  text-decoration: none;
  vertical-align: top;
  white-space: nowrap;
  min-width: 100px;
  height: 36px;
  margin: 6px 8px;
  -webkit-user-select: none;
  user-select: none;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 500;
  top: 80px;
  right: 80px;
  cursor: pointer;
  box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%),
    0 1px 5px 0 rgb(0 0 0 / 12%);
  color: #fff;
  color: var(--md-theme-default-text-primary-on-primary, #fff);
  background-color: #e94e1b;
  position: absolute;
}
.send-email-btn a,
.send-email-btn span {
  color: white !important;
  font-weight: bold !important;
}

.email-legend button {
  background: white !important;
}

.email-legend button i {
  color: rgba(0, 0, 0, 0.54) !important;
}
</style>